import { render, staticRenderFns } from "./fccTratamentoInscricoes.vue?vue&type=template&id=8bc2493e"
import script from "./fccTratamentoInscricoes.vue?vue&type=script&lang=js"
export * from "./fccTratamentoInscricoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports